import styled from "styled-components";
import {
  ContainerForm as ContainerFormDevolution,
  Error as ErrorDevolution,
  Form as FormDevolution,
} from "../create/styles";

export const Container = styled.div`
  grid-area: APP;
  padding: 10px 1rem 50px 1rem;

  height: 100%;
  max-height: 100vh;
  overflow-y: scroll;

  h3 {
    font-size: 18;
    color: #333;
    margin-top: 5px;
    margin-bottom: 10px;
    padding: 0 0px;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: #333;
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: #888;
  }

  header {
    margin-bottom: 10px;

    display: flex;
    flex-direction: row;

    width: 100%;
    background: #f0f0f0;
    box-shadow: 0px 0px 0px 4px #f0f0f0;

    padding: 15px 0;
    top: -20px;
    position: sticky;
    z-index: 10;

    h2 {
      display: flex;
      align-items: center;
      font-size: 1.2rem;
    }

    .containerActions {
      display: flex;
      align-items: center;
      margin-left: 10px;

      .buttonActionDatasheet {
        background: transparent;
        padding: 5px 8px;

        border-radius: 6px;
        font-weight: bold;
        font-size: 14px;

        transition: background 0.3s;

        div {
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            margin-right: 4px;
          }
        }

        &:hover {
          background: rgba(0, 0, 0, 0.2);
        }
      }
    }

    .arrowBack {
      display: flex;
      justify-content: center;
      align-items: center;

      margin-right: 10px;

      height: 30px;
      width: 30px;

      border-radius: 50%;

      transition: all 0.4s;

      &:hover {
        background-color: #ccc;
      }
    }

    .reportDownload {
      margin-left: 20px;

      span {
        color: #259457;
        font-size: 12px;
      }
    }

    .infoUpdate {
      position: absolute;
      /* top: 0px; */
      right: 0px;

      span {
        font-size: 0.8rem;
        color: #555;
        font-weight: 300;
      }
    }

    @media (max-width: 1015px) {
      margin-left: 0px;
      justify-content: space-between;

      .reportDownload {
        margin-left: 0;
      }

      .infoUpdate {
        position: absolute;
        top: 45px;
        right: 0px;
      }
    }

    @media (max-width: 530px) {
      margin-left: 0px;
      justify-content: space-between;

      .reportDownload {
        margin-left: 0;

        .text-execel {
          display: none;
        }
      }

      .infoUpdate {
        position: absolute;
        /* top: 30px; */
        right: 0px;
      }
    }
  }
`;

export const InfoDevolution = styled.div`
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 20px;
  flex: 1;

  h2 {
    font-size: 1rem;
    color: #111;
    font-weight: 500;
    font-weight: lighter;
    text-transform: uppercase;
  }

  h3 {
    font-size: 16px;
    color: #333;
    white-space: nowrap;
  }

  .line {
    height: 2px;
    width: 100%;
    background-color: #777;
    margin-bottom: 5px;
  }

  h4 {
    font-size: 14px;
    color: #333;
    margin-top: 8px;

    &:first-child {
      margin-top: 0;
    }
  }

  .containerOBS {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    padding: 0 10px;

    span {
      font-size: 14px;
      margin-bottom: 12px;
      color: #555;
    }

    div {
      width: 100%;
      background: #ddd;

      padding: 10px 20px;
      border-radius: 6px;

      max-height: 150px;
      overflow-y: scroll;

      p {
        color: #333;
        display: flex;
        flex: 1;
      }
    }
  }

  .reportDownload {
    background-color: transparent;
  }

  .headerDevoltion {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    height: 45px;
    background-color: #ccc;

    .containerTracking {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: transparent;

      &:nth-child(1) {
        margin-right: 4px;
      }
      &:nth-child(2) {
        margin-right: 4px;
      }

      button,
      a {
        display: flex;
        justify-content: center;
        align-items: center;

        background-color: #ddd;
        color: #000;
        padding: 5px 8px;
        border: 2px solid #333;

        border-radius: 6px;
        font-weight: bold;
        font-size: 14px;

        transition: all 0.2s ease-in;

        span {
          margin-right: 5px;
        }

        &:hover {
          opacity: 0.8;
        }
      }

      @media (max-width: 900px) {
        p {
          display: none;
        }

        button,
        a {
          span {
            margin-right: 0px;
          }
        }

        &:nth-child(1) {
          margin-right: 3px;
        }
        &:nth-child(2) {
          margin-right: 3px;
        }
      }
    }

    .containerActions {
      position: relative;
      &:hover .itemsActions {
        display: block;
      }

      .buttonActions {
        background-color: #fff;
        padding: 5px 8px;
        background: transparent;
        border: 2px solid #333;

        border-radius: 6px;
        font-weight: bold;
        font-size: 14px;
      }

      .buttonActionDatasheet {
        background-color: #fff;
        padding: 5px 8px;
        background: transparent;
        border: 2px solid #333;

        border-radius: 6px;
        font-weight: bold;
        font-size: 14px;
      }

      .itemsActions {
        display: none;
        position: absolute;
        right: 0;

        box-shadow: 0 0 6px 0px rgba(0, 0, 0, 0.4);
        border-radius: 8px;
        background: #fff;
        padding: 6px 10px;
        white-space: nowrap;

        li {
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #f00;
          z-index: 1;
          cursor: pointer;

          svg {
            margin-right: 5px;
          }
        }
      }

      .buttonAction {
      }
    }
  }

  .bodyDevoltion {
    background-color: #fff;
    padding: 8px 8px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .h4-form {
      margin-bottom: 10px;
      margin-top: 5px;
      margin-left: 5px;
      color: #444;
    }

    .conatinerInfo {
      flex: 1;
      width: 100%;
      padding: 0 4px;

      div {
        min-width: 260px;
        padding: 0 4px;
        margin-bottom: 15px;

        p {
          font-weight: 400;
          font-size: 16px;
          color: #333;
        }

        span {
          font-weight: 400;
          font-size: 14px;
          color: #555;
          word-break: break-all;
        }
      }

      .containerTitle {
        margin: 0px;
        display: flex;
        align-items: flex-end;

        a {
          display: flex;
          align-items: center;

          margin-left: 15px;
          color: #444;
          font-size: 13px;

          svg {
            margin-right: 4px;
          }
        }
      }
    }
  }

  .bodyChat {
    padding: 10px 15px;
    margin: 0;

    max-height: 300px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column-reverse;

    background: #fff;

    .containerchat {
      height: auto;
      width: 70%;

      margin-bottom: 0;
      margin-top: 10px;

      span {
        font-weight: 700;
      }

      p {
        width: 100%;
        height: auto;
        white-space: pre-wrap;
        padding: 8px 0 0 0;
      }
    }

    .containerMessage {
      padding: 5px 8px;
      margin-bottom: 5px;
    }

    .i {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding: 0;
      margin-bottom: 2px;

      .containerMessage {
        background-color: #ededed;
        border-radius: 10px 0 10px 10px;
      }

      header {
        text-align: right;
      }

      p {
        padding: 4px 0;
      }
    }

    .to {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      padding: 0;
      margin-bottom: 3px;

      .containerMessage {
        border: 2px solid #c7c7c7;
        border-radius: 0 10px 10px 10px;
      }
    }

    header {
      padding: 0;
      margin: 0;
    }

    footer {
      width: 100%;

      padding: 0 10px 0 0;

      display: flex;
      justify-content: flex-end;

      font-size: 12px;
      font-weight: 400;
      color: #555;
    }
  }

  footer {
    background: #fff;
    padding: 5px 10px 10px 10px;

    div {
      /* height: 40px; */
      width: 100%;

      display: flex;
      justify-content: space-between;
      align-items: center;

      input,
      textarea {
        width: 95%;
        height: 46px;
        resize: vertical;

        padding: 10px 25px;
        margin-right: 10px;
        border-radius: 10px;

        font-size: 18px;
        border: 2px solid #888;

        ::-webkit-scrollbar {
          width: 6px;
        }

        ::-webkit-scrollbar-thumb {
          background: #999;
          border-radius: 10px;
          width: 4px;
        }

        ::-webkit-scrollbar-track {
          background: none;
        }
      }

      button {
        height: 40px;
        width: 40px;

        display: flex;
        justify-content: center;
        align-items: center;

        padding: 0 0 0 4px;

        border-radius: 50%;
        background-color: #d21e26;
        box-shadow: 0 0 6px 0px rgba(0, 0, 0, 0.4);
      }
    }
  }

  .containerImg {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;

    transition: all 150ms linear;

    span {
      margin-right: 8px;
      margin-bottom: 8px;
      font-size: 10px;

      transition: all 150ms linear;

      &:last-child {
        margin-right: 0;
      }

      cursor: pointer;
    }
    img {
      transition: all 150ms linear;
      max-width: 140px;
      max-height: 100px;

      border-radius: 4px;
    }

    a,
    aside {
      display: flex;
      align-items: flex-start;
      width: 100%;
      img {
        width: 40px;
        margin-right: 8px;
        margin-bottom: 8px;
      }
    }
  }
`;

export const BoxInfo = styled.div`
  flex: 1;
  padding: 1.5rem 2rem;
  margin-bottom: 1.5rem;
  max-width: 1220px;

  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
  overflow: hidden;

  h3 {
    font-size: 1.3rem;
    color: #333;
    margin-bottom: 1rem;
  }

  h4 {
    font-size: 1.2rem;
    color: #333;
    margin-bottom: 1rem;
  }
  h5 {
    font-size: 1.1rem;
    color: #333;
    margin-bottom: 0.2rem;
  }

  p {
    font-size: 0.875rem;
    color: #333;
    margin-bottom: 0.3rem;
  }

  .tag {
    font-size: 0.9rem;
    color: #555;
  }

  span {
    font-weight: lighter;
    color: #333;
  }

  ul {
    list-style-type: circle !important;
    li {
      margin-left: 0.8rem;
      color: #555;
      font-size: 0.875rem;
    }
  }
`;

export const InfoStatus = styled.div`
  width: 100%;
  margin-bottom: 25px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;

  .containerStatus {
    position: relative;
    height: 72px;
    flex: 1;
  }

  .bannerLine {
    height: 5px;
    width: 100%;
    background-color: rgba(136, 227, 138, 0.5);
    border-radius: 4px 4px 0 0;
    position: absolute;
  }

  .containerStatus {
    /* margin-right: 8px; */
    margin-bottom: 8px;
  }

  /* .containerStatus:last-child {
    margin-right: 0px;
  } */

  .box {
    flex: 1;
    min-width: 200px;
    height: 100%;
    padding: 8px 14px;
    border-radius: 4px;
    box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.3);
    background-color: #fff;
    overflow: auto;

    div {
      padding: 5px 0;
      h5 {
        font-size: 12px;
        color: #333;
      }
    }

    p {
      font-size: 15px;
      font-weight: 500;
    }

    span {
      font-size: 13px;
      font-weight: 400;
      border-radius: 4px;
      padding: 2px 5px;
    }
  }

  @media (max-width: 900px) {
    flex-direction: column;

    .containerStatus {
      margin-left: 0;
      margin-bottom: 0px;
      margin-top: 10px;
    }
  }
`;

export const Form = styled(FormDevolution)``;

export const ContainerForm = styled(ContainerFormDevolution)``;

export const ContainerFile = styled.div`
  width: 100%;
  background: #fff;
`;

export const DetailFile = styled.div`
  width: 100%;
  height: 42vh;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  flex-direction: column;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    word-break: break-all;

    svg {
      margin-right: 5px;
    }

    font-weight: 700;
    font-size: 20px;
    color: #333;

    @media (max-width: 700px) {
      font-size: 14px;
    }
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  iframe {
    width: 100%;
    height: 100%;
  }

  img {
    cursor: pointer;

    max-width: 100%;
    max-height: 98%;
  }
`;

export const ListFile = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  overflow-x: scroll;

  background: rgba(200, 200, 200, 0.9);
  padding: 5px 5px 5px 5px;

  transition: all 150ms linear;

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #333;
    border-radius: 10px;

    &:hover {
      background: #222;
    }
  }

  button {
    max-width: 100px;
    margin-right: 20px;
    background: transparent;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      max-width: 60px;
      max-height: 60px;
      background: #fff;
      border-radius: 8px;
      padding: 2px;
    }

    span {
      color: #333;
      margin-top: 4px;
      word-break: break-all;
    }
  }
`;

export const ButtunSubmit = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 50px;
  margin-top: 20px;

  font-weight: 700;
  font-size: 16px;
  color: #fff;

  background: #d21e26;
  border-radius: 4px;

  &:hover {
    opacity: 0.85;
  }
`;

export const ButtunTable = styled.button`
  height: 100%;

  padding: 8px;
  font-weight: 700;
  font-size: 16px;
  color: #fff;

  background: #d21e26;
  border-radius: 4px;

  &:first-child {
    margin-right: 8px;
  }

  &:hover {
    opacity: 0.85;
  }
`;

export const Error = styled(ErrorDevolution)``;

export const ContainerDropZone = styled.div`
  width: 100%;
`;

// export const ContainerPreviews = styled.ul`
//   margin-top: 25px;
//   width: 100%;

//   display: flex;
//   justify-content: flex-start;
//   flex-direction: column;

//   max-width: 73vw;
//   overflow-x: scroll;

//   ::-webkit-scrollbar {
//     display: none;
//   }

//   li {
//     display: flex;
//     align-items: center;
//     margin-right: 20px;
//     margin-bottom: 12px;
//     img {
//       border-radius: 10px;
//       height: 60px;
//     }

//     .fileInfo {
//       margin-left: 5px;
//       display: flex;
//       flex-direction: column;

//       strong {
//         font-size: 14px;
//       }

//       span {
//         font-size: 12px;
//       }

//       button {
//         margin-top: 5px;
//         background: none;
//         color: #f00;
//         width: 20px;
//       }
//     }
//   }
// `;

export const ContainerPreviews = styled.ul`
  width: 100%;

  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  li {
    width: 100%;
    display: flex;
    align-items: center;
    background: #f0f0f0;
    padding: 10px 10px;
    margin-top: 10px;
    border-radius: 8px;

    img {
      height: 50px;
    }

    .fileInfo {
      margin-left: 5px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;

      div {
        display: flex;
        flex-direction: column;
        margin: 0 5px;
      }

      strong {
        white-space: nowrap;
        font-size: 14px;
      }

      span {
        font-size: 12px;
        color: #333;
      }

      button {
        margin-right: 10px;
        background: none;
        color: #f00;
      }
    }
  }
`;

export const ContainerCheck = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  width: 100%;
  height: 40px;

  border: 2px solid #d21e26;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s;

  button {
    border-radius: 0px;
    flex: 1;

    background: #fff;
    font-weight: bold;
    color: #333;

    border-right: 2px solid #d21e26;

    transition: all 0.3s;
  }

  button:first-child {
    border-right: 2px solid #d21e26;
  }

  button:last-child {
    border-left: 0px solid #d21e26;
    border: none;
  }

  .check {
    background: #d21e26;
    color: #fff;
  }
`;

export const ContainerCheckGrey = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  width: 100%;
  height: 40px;

  border: 2px solid #555;
  border-radius: 4px;
  overflow: hidden;

  button {
    border-radius: 0px;
    flex: 1;

    background: #fff;
    font-weight: bold;
    color: #333;
  }

  button:first-child {
    border-right: 2px solid #555;
  }

  button:last-child {
    border-left: 2px solid #555;
  }

  .check {
    background: #555;
    color: #fff;
  }
`;

export const TableContainer = styled.div`
  width: 100%;

  max-width: 100vw;
  overflow-y: auto;

  /* ::-webkit-scrollbar {
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background: #333;
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: #eee;
  } */

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 10;

    thead {
      background-color: #eee;

      tr {
        th {
          z-index: 1;
          background-color: #eee;
          position: sticky;
          top: 0;
          padding: 6px 8px;
          font-size: 16px;
          color: #444;
          white-space: nowrap;
        }
      }
    }

    tbody {
      background-color: #fff;

      tr {
        color: #777;
        border-bottom: 2px solid #eee;
        cursor: pointer;

        &:hover {
          background-color: #eee;
        }

        .td-img-logo {
          img {
            width: 6rem;
            height: 5rem;
            object-fit: cover;
            margin: auto auto;
            display: block;
            padding: 4px;
            border-radius: 12px;
          }
        }

        td {
          position: relative;
          height: 35px;
          text-align: center;
          padding: 0 6px;

          .notification {
            display: flex;
            align-items: center;
            position: absolute;
            left: 8px;
            top: 0px;
            height: 100%;
          }
          .status {
            color: #000;
            font-size: 13px;
            font-weight: 500;
            border-radius: 4px;
            padding: 2px 5px;
            white-space: nowrap;
          }

          .stuationContainer {
            width: 100%;

            button {
              width: 40px;
              margin: 0 auto;

              background: transparent;
            }

            div {
              width: 40px;
              margin: 0 auto;
            }

            svg {
              transition: transform 0.2s ease-in-out;

              &:hover {
                transform: scale(1.3);
              }
            }
          }
        }
      }
    }
  }
`;

export const TableContainerProducts = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow-y: auto;

  table {
    width: 100%;
    border-collapse: collapse;

    thead {
      background-color: #eee;

      tr {
        th {
          z-index: 2;
          background-color: #eee;
          position: sticky;
          top: 0;
          padding: 6px 8px;
          font-size: 16px;
          color: #444;
          white-space: nowrap;
        }
      }
    }

    tbody {
      tr {
        color: #777;
        border-radius: 6px;
        cursor: pointer;
        background-color: #fff;

        td {
          position: relative;
          height: 35px;
          text-align: center;
          padding: 0 6px;

          img {
            width: 80px;
          }

          .notification {
            display: flex;
            align-items: center;
            position: absolute;
            left: 8px;
            top: 0px;
            height: 100%;
          }
          .status {
            color: #000;
            font-size: 13px;
            font-weight: 500;
            border-radius: 4px;
            padding: 2px 5px;
            white-space: nowrap;
          }

          .stuationContainer {
            width: 100%;

            button {
              width: 40px;
              margin: 0 auto;

              background: transparent;
            }

            div {
              width: 40px;
              margin: 0 auto;
            }

            svg {
              transition: transform 0.2s ease-in-out;

              &:hover {
                transform: scale(1.3);
              }
            }
          }
        }
      }

      tr + tr {
        margin-top: 10px;
      }
    }
  }
`;

export const ContainerListProducts = styled.div`
  /* border-radius: 4px; */
  /* box-shadow: 0 0 2px rgba(0, 0, 0, 0.2); */
  .headerTable {
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 45px;
    /* background-color: #ccc; */

    h3 {
      font-size: 1rem;
      color: #333;
      font-weight: lighter;
    }

    button {
      padding: 8px 10px;
      height: 28px;
      background-color: #d21e26;
      border-radius: 5px;

      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.3s;

      &:hover {
        opacity: 0.6;
      }

      svg {
        color: #fff;
        margin-right: 2px;
      }

      span {
        font-size: 12px;
        color: #fff;
        font-weight: 500;
      }

      @media (max-width: 550px) {
        span {
          display: none;
        }
      }
    }
  }
`;

export const ContainerList = styled.div`
  border-radius: 4px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
  .headerTable {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    height: 45px;
    background-color: #ccc;

    h3 {
      font-size: 18px;
      color: #111;
      font-weight: 500;
    }

    button {
      padding: 8px 10px;
      height: 28px;
      background-color: #d21e26;
      border-radius: 5px;

      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.3s;

      &:hover {
        opacity: 0.6;
      }

      svg {
        color: #fff;
        margin-right: 2px;
      }

      span {
        font-size: 12px;
        color: #fff;
        font-weight: 500;
      }

      @media (max-width: 550px) {
        span {
          display: none;
        }
      }
    }
  }
`;

export const FooterContainer = styled.div`
  height: 55px;
  width: 100%;
  padding: 10px 10px;
  margin-bottom: 20px;

  background-color: #fff;

  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 550px) {
    height: 80px;
  }

  nav {
    display: flex;
    height: 100%;

    justify-content: space-between;
  }

  span {
    padding-bottom: 10px;
    font-size: 12px;
    font-weight: 400;
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    @media (max-width: 500px) {
      flex-direction: column;
    }

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;

      height: 30px;
      padding: 15px 15px;
      margin-right: 10px;

      font-weight: 700;
      background-color: #fff;
      transition: all 0.8s;
      color: #555;
    }

    button:hover {
      background-color: #ccc;
    }
  }
`;

export const Infogroup = styled.div`
  display: grid;
  grid-template-columns: 48% 50%;
  grid-template-rows: 1fr 1fr;
  grid-template-areas:
    "FP HT"
    "FP HT";
  grid-gap: 0px 2%;

  div {
    box-shadow: none;
  }

  @media (max-width: 950px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;

    grid-template-areas:
      "FP"
      "HT";

    div {
      width: 100%;
    }
  }
`;

export const PaymentDetailCard = styled.div`
  width: 100%;
  background-color: #fff;
  padding: 10px 10px;
  margin-bottom: 15px;
`;
export const HeaderPaymentDetailCard = styled.div`
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .arrow {
    transition: 0.4s;
    transform: rotate(0deg);
  }

  .arrow-active {
    transform: rotate(180deg);

    transition: 0.4s;
  }

  div {
    padding: 0 10px;

    h4 {
      color: #008000;
    }

    p {
      font-weight: 400;
      font-size: 16px;
      color: #333;
    }

    span {
      font-weight: 400;
      font-size: 14px;
      color: #555;
    }
  }
`;
export const BodyPaymentDetailCard = styled.div`
  div {
    button {
      display: flex;
      align-items: center;
      background-color: transparent;

      & > svg {
        margin-left: 5px;
      }
    }

    padding: 0 10px;
    margin-bottom: 10px;
    p {
      font-weight: 400;
      font-size: 16px;
      color: #333;
    }

    span {
      font-weight: 400;
      font-size: 14px;
      color: #555;

      pre {
        overflow-x: scroll;
        max-width: 100%;

        padding: 10px;
        border-radius: 4px;
      }
    }
  }
`;

export const ScreenLoading = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SlaContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 100px;
  flex: 1;
  height: 100%;

  .boxSla {
    position: relative;
    overflow: hidden;

    height: 65%;
    max-height: 23px;
    width: 90%;

    background-color: #fbfbfb;
    border-radius: 8px;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);

    .percentageSla {
      position: absolute;
      margin: auto;

      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;

      span {
        font-size: 12px;
        font-weight: 700;
        color: #444;
      }
    }

    .valueSla {
      height: 100%;
      width: 25%;

      /* background-color: rgba(255, 220, 0, 0.6); */
      /* background-color: rgba(255, 61, 61, 0.8); */
      background-color: rgba(90, 182, 95, 0.8);
    }
  }
`;

export const PopUpConfirmation = styled.div`
  width: 100%;
  height: 100%;
  padding: 35px 0;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .headerPopUp {
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    nav {
      display: flex;
      justify-content: center;

      margin-bottom: 35px;
    }

    span {
      font-size: 18px;
      color: #555;
      font-weight: 600;
      padding: 0 15px;
      text-align: center;
      margin-bottom: 4px;
    }

    .field {
      flex: 1;
      max-width: 550px;
      margin-top: 10px;
      padding: 10px 30px;
      /* width: 100%; */

      label {
        font-size: 20px;
        margin-bottom: 4px;
        color: #555;
      }

      textarea {
        padding: 10px 10px;
        background: #fff;
        height: 80px;
        width: 100%;
        font-size: 16px;
        color: #000;
        border: 2px solid #aaa;
        border-radius: 5px;
        /* resize: vertical; */
        resize: unset;

        ::-webkit-scrollbar {
          width: 8px;
        }

        ::-webkit-scrollbar-thumb {
          background: #333;
          width: 4px;
        }

        ::-webkit-scrollbar-track {
          background: #888;
        }

        &:focus {
          border: 2px solid #333;
        }
      }
    }
  }

  .buttonsPopUp {
    width: 100%;
    display: flex;
    justify-content: space-between;

    button {
      flex: 1;
      border-radius: 40px;
      padding: 10px 4px;
      font-weight: 700;
      font-size: 14px;
      border: 1.5px solid rgba(97, 97, 97, 0.4);

      transition: all 0.4s;

      &:nth-child(1) {
        margin: 0 0 0 40px;
        background-color: #fafafa;

        &:hover {
          opacity: 0.8;
        }
      }

      &:nth-child(2) {
        margin: 0 40px 0 30px;
        background-color: #1aa33f;
        color: #fff;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .field-group {
    display: flex;
    padding: 10px 50px;
    width: 100%;
    gap: 10px;
    flex-wrap: wrap;
    /* flex-flow: row; */

    .field {
      padding: 0;
    }
  }

  /* @media (max-width: 900px) {
    .field-group {
      flex-flow: column;
    }
  } */
`;

export const ObsText = styled.span`
  display: flex;
  align-items: center;
  margin-bottom: 6px;
`;

export const ContainerGroup = styled.div`
  /* width: 100%; */
  flex: 1;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  gap: 30px;

  @media (max-width: 1000px) {
    flex-flow: column;
    gap: 0;
  }
`;

export const ContainerButtons = styled.div`
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;

  button {
    background-color: rgb(32, 114, 69);
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    padding: 6px;
    border-radius: 6px;
  }
`;

export const ContainerImportModal = styled.div`
  header {
    margin-bottom: 10px;

    .download-file {
      a {
        width: 230px;

        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 20px;
        background: rgba(200, 200, 200, 0.8);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);

        &:hover {
          background: rgba(180, 180, 180, 0.8);
        }
        span {
          margin-left: 6px;
          margin-top: 2px;
        }

        display: flex;
        align-items: center;
        text-decoration: none;

        color: #333;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }

  padding: 10px;
`;

export const ObsSpan = styled.p`
  padding: 3px;
  color: #888;
  font-size: 0.75rem;
`;

export const BtnAction = styled.button`
  padding: 8px 10px;
  height: 28px;
  background-color: #d21e26;
  border-radius: 5px;

  display: flex;
  /* justify-content: space-between; */
  justify-content: center;
  align-items: center;
  transition: all 0.3s;

  &:hover {
    opacity: 0.6;
  }

  svg {
    color: #fff;
  }

  span {
    /* margin-left: 5px; */
    font-size: 12px;
    color: #fff;
    font-weight: 500;
  }

  @media (max-width: 750px) {
    svg {
      margin-right: 0px;
    }
    span {
      display: none;
    }
  }
`;

export const ContainerImageExample = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 2rem;

  div {
    display: flex;
    flex-direction: column;

    span {
      font-size: 1rem;
      color: #333;
      font-weight: lighter;
    }

    img {
      height: 200px;
      max-width: 100%;

      border-radius: 8px;
    }
  }
`;
